module.exports = __webpack_public_path__ + "img/s8-img4.32d4e014.png";